import { buildRequestToParams } from "../../applications/utils/StringUtils";
import { ApiClient } from "../api/ApiClient";
import { ProfitLossModel, ProfitLossRequest } from "../model/ProfitLossModel";

const BASE_ULR = "/api/profit-loss";

class ProfitLossServiceClass {
  getListOperatingCost(request: ProfitLossRequest) {
    const params = buildRequestToParams(request);
    return ApiClient.get<ProfitLossModel>(BASE_ULR + `/data?${params}`);
  }
}

const ProfitLossService = new ProfitLossServiceClass();
export default ProfitLossService;
